import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, ProjetsRoutingModule } from './projets-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PublishRenderComponent } from './publish-render.component';
import { EditProjetComponent } from './edit-projet/edit-projet.component';
import { CKEditorModule } from 'ngx-ckeditor';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    ProjetsRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
    CKEditorModule,
  ],
  entryComponents: [
    PublishRenderComponent,
    EditProjetComponent,
  ],
  declarations: [
    PublishRenderComponent,
    EditProjetComponent,
    ...routedComponents,
  ],
})
export class ProjetsModule { }
